import { render, staticRenderFns } from "./Old-TransactionsOfBill.vue?vue&type=template&id=66756dc6"
import script from "./Old-TransactionsOfBill.vue?vue&type=script&lang=js"
export * from "./Old-TransactionsOfBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports